export class BarcodeHeadersDto {
    [key: string]: any;
}